function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import store from "../store";
import { setTranslationMissing } from "../store/actions/module";
var translate = function translate(key) {
  var _state$module, _state$module$diction;
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var state = store.getState();
  var translationMissing = state.module.translationMissing;
  var dictionary = ((_state$module = state.module) === null || _state$module === void 0 ? void 0 : (_state$module$diction = _state$module.dictionary) === null || _state$module$diction === void 0 ? void 0 : _state$module$diction.data) || null;
  var translation = dictionary ? dictionary[key] : null;
  if (!dictionary || !translation) {
    var _state$module2;
    // we shouldn't be displaying the notification for the signature home page
    if (window.location.href !== translationMissing.url && window.location.pathname !== '/signature' && key !== 'missing_translation_notification' && !translationMissing.showNotification) {
      store.dispatch(setTranslationMissing({
        showNotification: true,
        url: window.location.href
      }));
    }
    var enDictionary = (_state$module2 = state.module) === null || _state$module2 === void 0 ? void 0 : _state$module2.enDictionary;
    if (!enDictionary) {
      return "{{".concat(key, "}}");
    }
    translation = enDictionary ? enDictionary[key] : null;
    if (!translation) {
      return "{{".concat(key, "}}");
    }
  }
  var translateWithVariables = function translateWithVariables(string, vars) {
    var templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
    function isDefined(value) {
      return typeof value !== 'undefined' && value !== null;
    }
    function interpolateString(expr, params) {
      return expr.replace(templateMatcher, function (substring, b) {
        var r = getValue(params, b);
        return isDefined(r) ? r : substring;
      });
    }
    function getValue(target, key) {
      var keys = typeof key === 'string' ? key.split('.') : [key];
      key = '';
      do {
        key += keys.shift();
        if (isDefined(target) && isDefined(target[key]) && (_typeof(target[key]) === 'object' || !keys.length)) {
          target = target[key];
          key = '';
        } else if (!keys.length) {
          target = undefined;
        } else {
          key += '.';
        }
      } while (keys.length);
      return target;
    }
    return interpolateString(string, vars);
  };
  if (!data) {
    return translation;
  }
  return translateWithVariables(translation, data);
};
export { translate as t };
export default translate;